import { render, staticRenderFns } from "./addStao.vue?vue&type=template&id=1cb162d9&scoped=true&"
import script from "./addStao.vue?vue&type=script&lang=js&"
export * from "./addStao.vue?vue&type=script&lang=js&"
import style0 from "./addStao.vue?vue&type=style&index=0&id=1cb162d9&scoped=true&sass=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb162d9",
  null
  
)

export default component.exports